import { SlotsModel } from '../models/slots.model';
import RequestCreator from './helpers/requestCreator';

class Slot extends RequestCreator<SlotsModel> {}

const api = new Slot('/slots');
export default api;
